module.exports = __webpack_public_path__ + "static/media/rp_entry_banner.15cf7245.svg";